module.exports = __webpack_public_path__ + "img/footrest.5bc4bcc6.png";